import type { IMosaicTocExpanded, ITocActionAddSection } from "./interface";
import { MosaicTocSectionClass } from "./MosaicTocSectionClass";

/**
 * Adds a new unsaved section to the start of the ToC when the identifier is unique.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the new section identifier.
 * @returns The updated ToC state with the new section inserted when needed.
 */
export const toc_addSection = (
  state: IMosaicTocExpanded,
  action: ITocActionAddSection,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };

  /* istanbul ignore else -- reducer callers only dispatch unique identifiers. */
  if (newState.tocItems.findIndex((item) => item.id === action.newId) === -1) {
    const newSection = new MosaicTocSectionClass({
      id: action.newId,
      primaryHierarchyId: newState.hierarchyId,
      sectionLabel: "",
      sectionNumber: "",
      order:
        newState.tocItems
          .map(
            (item) =>
              item.tocOrder ??
              // istanbul ignore next -- all ToC items should carry an order before insertion.
              0,
          )
          .reduce((first, second) => Math.min(first, second), 0) - 1,
      changed: true,
    });
    newState.tocItems.splice(0, 0, newSection);
    newState.saving = true;
  }

  return newState;
};
